export default __webpack_public_path__ + "static/media/element_4.9bdf4535.webp";